import { messagesEN } from './lib/intl/en-US';
import { Options } from '@sheerid/jslib';
import { RecursivePartial } from './lib/types/types';


export const programId = '5f739180bbf6e1181e5dfa8d';

export const defaultOptions: RecursivePartial<Options> = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com',
    },
    logLevel: 'error',
    useFingerprinting: true,
    messagesWithLocale: {
        'en-US': messagesEN,
    },
};
